module.exports = __webpack_public_path__ + "cef95ba6ac579c893d38286150ea4e79.svg";